import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppTradeSmartLoginComponent } from "src/app/shared-module/dialog/trade-smart/trade-smart.component";
import { RiskprofileComponent } from 'src/app/shared-module/dialog/riskprofile/riskprofile.component';
import { ExternalOrderComponent } from '@app/investment/dialogs/external-order/external-order.component';
// import { PredictionDetailComponent } from '@app/predictions/prediction-detail/prediction-detail.component';
import { UpiIDComponent } from '@shared/module/dialog/upi-id/upi-id.component';
import { DematAccountComponent } from '@shared/module/demat-account/demat-account.component';
import { AppSipSettingComponent } from '@shared/module/sip-setting/sip-setting.component';
import { MfCreationComponent } from '@shared/module/dialog/mf-creation/mf-creation.component';
import { WatchVideoComponent } from '@shared/module/dialog/watch-video/watch-video.component';
import { DirectPurchaseDialogComponent } from '@shared/module/dialog/direct-purchase-dialog/direct-purchase-dialog.component';
import { RiskProfileIncompleteComponent } from '@shared/module/dialog/risk-profile-incomplete/risk-profile-incomplete.component';
import { EditTransactionDialogComponent } from '@shared/module/dialog/edit-transaction-dialog/edit-transaction-dialog.component';
import { UpdateHoldingsDialogComponent } from '@shared/module/dialog/update-holdings-dialog/update-holdings-dialog.component';
import { AppPaymentOptionComponent } from '@shared/module/payment-option/payment-option.component';
import { RebalanceComponent } from '@app/investment/dialogs/rebalance/rebalance.component';
import { RiskMismatchComponent } from '@app/investment/dialogs/risk-mismatch/risk-mismatch.component';
import { AppNewsDetailComponent } from '@shared/module/news-detail/news-detail.component';
import { FinvasiaComponent } from '@shared/module/dialog/finvasia/finvasia.component';
import { PopupComponent } from '@shared/module/dialog/popup/popup.component';
import { AppUserMenuComponent } from '@shared/module/user-menu/user-menu.component';
import { ReferralRewardComponent } from '@shared/module/referral-reward/referral-reward.component';
import { AdvisorComplaintsComponent } from '@shared/module/advisor-complaints/advisor-complaints.component';
import { OfferRewardsComponent } from '@shared/module/offer-rewards/offer-rewards.component';
import { CouponRewardComponent } from '@shared/module/coupon-reward/coupon-reward.component';
import { ClaimRewardComponent } from '@shared/module/dialog/claim-reward/claim-reward.component';
import { ReferTransactionComponent } from '@shared/module/dialog/refer-transaction/refer-transaction.component';
import { ConfirmDialogComponent } from '@shared/module/dialog/confirm/confirm-dialog.component';
import { MatDialogConfig, NgDialogAnimationService } from './dialog.animation.service';
import { PriceFeedBrokerDialogComponent } from '@app/trading/price-feed-broker-dialog/price-feed-broker-dialog.component';
import { TradingSubscriptionDialogComponent } from '@app/trading/subscription-dialog/subscription-dialog.component';
import { TradeCallDialogComponent } from '@app/trading/trade-call-dialog/trade-call-dialog.component';
import { PredictionDetailComponent } from '@app/predictions/prediction-detail/prediction-detail.component';
import { KotakComponent } from '@shared/module/dialog/kotak/kotak.component';

@Injectable({ providedIn: "root" })
export class DialogService {

  constructor(
    private matDialog: NgDialogAnimationService
  ) { }

  openTemplateDialog(
    template: any,
    config: MatDialogConfig = {},
    data: any = {}
  ): MatDialogRef<any> {
    let dialogConfig: MatDialogConfig = {
      maxWidth: "900px",
      disableClose: true,
      width: "100%",
      height: "100%",
      minHeight: "fit-content",
      data: data,
      ...config,
    };
    return this.matDialog.open(template, dialogConfig);
  }

  openTradeSmartDialog(
    config: any = {},
    data: any = {}
  ): MatDialogRef<AppTradeSmartLoginComponent> {
    let dialogConfig: any = {
      maxWidth: "900px",
      disableClose: true,
      width: "490px",
      height: "auto",
      data: data,
      ...config,
    };
    return this.matDialog.open(AppTradeSmartLoginComponent, dialogConfig);
  }

  closeAll(dialog?: any) {
    if (dialog) {
      dialog.close();
    } else {
      this.matDialog.closeAll();
    }
  }

  openRiskProfileDialog(
    config: MatDialogConfig,
    data?: { planId: string; investpackID: string }
  ): MatDialogRef<RiskprofileComponent> {
    let dialogConfig: MatDialogConfig = {
      maxWidth: "90vh",
      data: data,
      width: "380px",
      panelClass: ["bottomSheet", "no-padding", "border-radius-dialog-8"],
      ...config,
    };
    return this.matDialog.open(RiskprofileComponent, dialogConfig);
  }

  openRiskMismatchDialog(
    config: MatDialogConfig,
    data?: any
  ): MatDialogRef<RiskMismatchComponent> {
    let dialogConfig: MatDialogConfig = {
      maxWidth: "100vh",
      width: "max-content",
      height: "50%",
      data: data,
      panelClass: [
        "bottomSheet",
        "no-padding",
        "border-radius-dialog-8",
        "width-max",
        "height-40",
        "height-md-70-pr",
      ],
      ...config,
    };
    return this.matDialog.open(RiskMismatchComponent, dialogConfig);
  }

  openMfCreationDialog(
    config: MatDialogConfig,
    data?: any
  ): MatDialogRef<MfCreationComponent> {
    let dialogConfig: MatDialogConfig = {
      maxWidth: "90vh",
      width: "976px",
      data: data,
      minHeight: "350px",
      panelClass: ["bottomSheet", "no-padding", "border-radius-dialog-8"],
      ...config,
    };
    return this.matDialog.open(MfCreationComponent, dialogConfig);
  }

  closeDialogbyId(id: string, data: any = null) {
    const dialog = this.matDialog.getDialogById(id);
    if (dialog) {
      dialog.close(data);
    }
  }

  openExternalInvestmentDialog(config: MatDialogConfig, data?: any): MatDialogRef<ExternalOrderComponent> {
    let dialogConfig: MatDialogConfig = {
      maxWidth: '80vh',
      data: data,
      panelClass: ['bottomSheet'],
      ...config
    };
    return this.matDialog.open(ExternalOrderComponent, dialogConfig)
  }


  openRebalanceDialog(config: MatDialogConfig, data?: any): MatDialogRef<RebalanceComponent> {
    let dialogConfig: MatDialogConfig = {
      maxWidth: '600px',
      width: '700px',
      data: data,
      panelClass: ['bottomSheet'],
      ...config
    };
    return this.matDialog.open(RebalanceComponent, dialogConfig)
  }

  openPredictionDetailDialog(config: MatDialogConfig, data: any): MatDialogRef<PredictionDetailComponent> {
    let dialogConfig: MatDialogConfig = {
      disableClose: true,
      width: "50%",
      maxHeight: "80%",
      data: data,
      ...config
    }
    return this.matDialog.open(PredictionDetailComponent, dialogConfig)
  }

  openUpiIDDialog(config: MatDialogConfig): MatDialogRef<UpiIDComponent> {
    let dialogConfig: MatDialogConfig = {
      width: '400px',
      panelClass: ['bottomSheet'],
      ...config
    };
    return this.matDialog.open(UpiIDComponent, dialogConfig)
  }

  openSipSettingsDialog(config: MatDialogConfig, data: { id: string, sipDate: any, sipAmount: number }) {
    let dialogConfig: MatDialogConfig = {
      maxWidth: '410px',
      height: 'auto',
      data: data,
      ...config
    }
    return this.matDialog.open(AppSipSettingComponent, dialogConfig)
  }

  openDematDialog(
    config: MatDialogConfig
  ): MatDialogRef<DematAccountComponent> {
    let dialogConfig: MatDialogConfig = {
      panelClass: ["bottomSheet"],
      width: "800px",
      height: "300px",
      ...config,
    };
    return this.matDialog.open(DematAccountComponent, dialogConfig);
  }

  openWatchVideoDialog(
    config: MatDialogConfig,
    data: { src: string; poster: string, caption?: any }
  ): MatDialogRef<WatchVideoComponent> {
    let dialogConfig: MatDialogConfig = {
      data: data,
      panelClass: ["full-md", "max-width-md-100-pr"],
      ...config,
    };
    return this.matDialog.open(WatchVideoComponent, dialogConfig);
  }

  openUpdateInvestpackHoldings(config: MatDialogConfig, data: any): MatDialogRef<UpdateHoldingsDialogComponent> {
    let dialogConfig: MatDialogConfig = {
      data: data,
      minWidth: '50%',
      panelClass: ['no-padding', 'border-radius-dialog-16'],
      ...config
    }
    return this.matDialog.open(UpdateHoldingsDialogComponent, dialogConfig)
  }

  openDirectPurchaseDialog(config: MatDialogConfig, data: any): MatDialogRef<DirectPurchaseDialogComponent> {
    let dialogConfig: MatDialogConfig = {
      data: data,
      minWidth: '40%',
      panelClass: ['no-padding', 'border-radius-dialog-16'],
      ...config
    }
    return this.matDialog.open(DirectPurchaseDialogComponent, dialogConfig)
  }

  openEditTransactionDialog(config: MatDialogConfig, data: any): MatDialogRef<EditTransactionDialogComponent> {
    let dialogConfig: MatDialogConfig = {
      data: data,
      minWidth: '40%',
      panelClass: ['no-padding', 'border-radius-dialog-16'],
      ...config
    }
    return this.matDialog.open(EditTransactionDialogComponent, dialogConfig)
  }

  openRiskProfileIncompleteDialog(config: MatDialogConfig): MatDialogRef<RiskProfileIncompleteComponent> {
    let dialogConfig: MatDialogConfig = {
      width: "100%",
      maxWidth: "100%",
      ...config,
    };
    return this.matDialog.open(RiskProfileIncompleteComponent, dialogConfig);
  }
  getDialogById(dialogId: string) {
    return this.matDialog.getDialogById(dialogId);
  }

  opemMFPaymentOptionsDialog(config: MatDialogConfig, data: any): MatDialogRef<AppPaymentOptionComponent> {
    let dialogConfig: MatDialogConfig = {
      maxWidth: '390px',
      height: 'auto',
      panelClass: ['no-padding', 'bootomSheet'],
      data: data,
      ...config,
    }
    return this.matDialog.open(AppPaymentOptionComponent, dialogConfig)
  }

  openTradeDialog(
    config: MatDialogConfig,
    data: { call: any; packId: any; tradeData: any; isExit: boolean }
  ): MatDialogRef<TradeCallDialogComponent> {
    let dialogConfig: MatDialogConfig = {
      maxWidth: "max-content",
      width: "80%",
      height: "auto",
      panelClass: [
        "no-padding",
        "trade-call-dialog",
        "bottomSheet",
        "height-md-100-pr",
        "bg-color-202028",
        "border-radius-24",
        "min-height-md-fit",
      ],
      data: data,
      disableClose: false,
      ...config,
    };
    return this.matDialog.open(TradeCallDialogComponent, dialogConfig);
  }

  openNewsDetailDialog(
    config: MatDialogConfig,
    newsId: string
  ): MatDialogRef<AppNewsDetailComponent> {
    let dialogConfig: MatDialogConfig = {
      height: "auto",
      maxWidth: "460px",
      panelClass: ["!tw-p-0", "dialog-bg-transparent", "news-detail"],
      disableClose: false,
      data: newsId,
      ...config,
    };
    return this.matDialog.open(AppNewsDetailComponent, dialogConfig);
  }
  openFinvasiaDialog(
    config: any = {},
    data: any = {}
  ): MatDialogRef<FinvasiaComponent> {
    let dialogConfig: any = {
      maxWidth: "900px",
      disableClose: true,
      width: "490px",
      height: "auto",
      data: data,
      panelClass: ["bottomSheet"],
      ...config,
    };
    return this.matDialog.open(FinvasiaComponent, dialogConfig);
  }
  openPopupDailog(config: MatDialogConfig, data: any): MatDialogRef<PopupComponent> {
    let dialogConfig: MatDialogConfig = {
      height: "auto",
      panelClass: ["popup"],
      disableClose: false,
      data: data,
      ...config,
    };
    return this.matDialog.open(PopupComponent, dialogConfig);
  }

  openUserMenu(
    config: MatDialogConfig,
    data?: any
  ): MatDialogRef<AppUserMenuComponent> {
    let dialogConfig: MatDialogConfig = {
      panelClass: ['sideSheet'],
      maxWidth: '500px',
      position: { right: '0px' },
      height: '100vh',
      disableClose: false,
      data: data,
      animation: { to: 'left' },
      ...config,
    };
    return this.matDialog.open(AppUserMenuComponent, dialogConfig);
  }

  openReferralRewardDialog(
    config: MatDialogConfig,
    data: { availableRewards: any[]; page: string; currentRewards: any[] }
  ): MatDialogRef<ReferralRewardComponent> {
    let dialogConfig: MatDialogConfig = {
      width: "430px",
      height: "auto",
      data: data,
      panelClass: ["border-radius-dialog-16", "no-padding", "bottomSheet"],
      ...config,
    };
    return this.matDialog.open(ReferralRewardComponent, dialogConfig);
  }

  openTradingSubscriptionPlans(
    config: MatDialogConfig,
    dialogData: { _id: string; packName: string; currentPlan?: any }
  ): MatDialogRef<TradingSubscriptionDialogComponent> {
    let dialogConfig: MatDialogConfig = {
      height: "auto",
      maxWidth: "1120px",
      width: "100%",
      minWidth: "320px",
      panelClass: ["no-padding", "no-bg", "bottomSheet"],
      data: dialogData,
      ...config,
    };
    return this.matDialog.open(
      TradingSubscriptionDialogComponent,
      dialogConfig
    );
  }

  openAdvisorComplaintDialog(config: MatDialogConfig, data: any): MatDialogRef<AdvisorComplaintsComponent> {
    let dialogConfig: MatDialogConfig = {
      height: 'auto',
      maxWidth: '1000px',
      panelClass: ['no-padding', 'bottomSheet'],
      data: data,
      ...config
    }
    return this.matDialog.open(AdvisorComplaintsComponent, dialogConfig)
  }

  openOfferRewardDialog(
    config: MatDialogConfig,
    data: { availableRewards: any[]; page: string; currentRewards: any[] }
  ): MatDialogRef<OfferRewardsComponent> {
    let dialogConfig: MatDialogConfig = {
      width: "430px",
      height: "auto",
      data: data,
      panelClass: ["border-radius-dialog-16", "no-padding", "bottomSheet"],
      ...config,
    };
    return this.matDialog.open(OfferRewardsComponent, dialogConfig);
  }
  openCouponRewardDialog(
    config: MatDialogConfig,
    data: any
  ): MatDialogRef<CouponRewardComponent> {
    let dialogConfig: MatDialogConfig = {
      width: "430px",
      height: "auto",
      data: data,
      panelClass: [
        "border-radius-dialog-16",
        "no-padding",
        "bottomSheet",
        "bg-color-F6FAFB-imp",
      ],
      ...config,
    };
    return this.matDialog.open(CouponRewardComponent, dialogConfig);
  }
  openPriceFeedBrokerDialog(
    config: MatDialogConfig
  ): MatDialogRef<PriceFeedBrokerDialogComponent> {
    let dialogConfig: MatDialogConfig = {
      width: "590px",
      height: "580px",
      maxHeight: "580px",
      ...config,
    };
    return this.matDialog.open(PriceFeedBrokerDialogComponent, dialogConfig);
  }
  openCliamRewardDialog(
    config: MatDialogConfig,
    data: any
  ): MatDialogRef<ClaimRewardComponent> {
    let dialogConfig: MatDialogConfig = {
      data: data,
      width: "1120px",
      height: "auto",
      panelClass: ["border-radius-dialog-24", "no-padding", "bottomSheet"],
      ...config,
    };
    return this.matDialog.open(ClaimRewardComponent, dialogConfig);
  }
  openReferralTransactionDialog(
    config: MatDialogConfig,
    data: any
  ): MatDialogRef<ReferTransactionComponent> {
    let dialogConfig: MatDialogConfig = {
      data: data,
      ...config,
    };
    return this.matDialog.open(ReferTransactionComponent, dialogConfig);
  }
  openCommonDialog(
    config: MatDialogConfig = {},
    data: { title: string; content: string; cancelBtn: string; okBtn: string }
  ): MatDialogRef<ConfirmDialogComponent> {
    let dialogConfig: MatDialogConfig = {
      disableClose: true,
      width: "600px",
      maxWidth: "400px",
      height: "auto",
      data: data,
      ...config,
    };
    return this.matDialog.open(ConfirmDialogComponent, dialogConfig);
  }

  openKotakaDialog(
    config: any = {},
    data: any = {}
  ): MatDialogRef<KotakComponent> {
    let dialogConfig: any = {
      disableClose: true,
      width: "490px",
      height: "522px",
      data: data,
      panelClass: ["bottomSheet"],
      ...config,
    };
    return this.matDialog.open(KotakComponent, dialogConfig);
  }

}
